import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonComponent } from '../../../../aptem-component-library/components/button/button.component';
import { CalloutComponent } from '../../../../aptem-component-library/components/callout/callout.component';
import { PageUtils } from '../../common/page.utils';
import { AssessmentService } from '../../services/assessment.service';
import { FixedContentPageComponent } from '../common/fixed-content/fixed-content.component';

@Component({
    selector: 'introduction',
    templateUrl: './introduction.component.html',
    styleUrls: ['./introduction.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent, ButtonComponent, FixedContentPageComponent, CalloutComponent]
})
export class IntroductionComponent implements AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageUtils: PageUtils,
    private assessmentService: AssessmentService,
  ) {}

  ngAfterViewInit(): void {
    this.assessmentService.loadInitialAssessment(this.route);
  }

  navigateToOverview() {
    this.assessmentService.setInitialTestlet();
    const url = this.pageUtils.buildParameterisedRoute('overview');
    this.router.navigateByUrl(url);
  }
}
